///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { _isEqual } from '../utils';
import { GtthLayerDtoModel } from '../../services/project-socket/dto/gtth-layer-dto.model';

@Component({
    selector: 'winde-multi-select',
    templateUrl: './multi-select.component.html',
    styleUrls: ['./multi-select.component.scss'],
    standalone: false
})
export class GtthMultiSelectComponent implements OnInit, OnChanges {
    @Input() availableList: GtthLayerDtoModel[];
    @Input() displayName: string;
    @Input() disabled: boolean;
    @Input() selectedList: string[];
    @Input() preselectedDisabledItems: string[];

    @Output() selectedListChange = new EventEmitter();

    selectionItems = [];

    ngOnInit() {
        this.selectionItems = this.availableList.slice();
        this.displayName = this.displayName || 'name';

        if (this.selectedList && this.selectedList.length > 0) {
            this.selectedList.forEach((item) => {
                this.toggleSelect(this.selectedList, item, false);
            });
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.selectedList && !_isEqual(changes.selectedList.currentValue, changes.selectedList.previousValue)) {
            this.selectedList = changes.selectedList.currentValue ?? [];
            if (this.selectedList && this.selectedList.length > 0) {
                this.selectedList.forEach((item) => {
                    this.toggleSelect(this.selectedList, item, false);
                });
            }
        }
    }

    toggleSelect(list: string[], item, emitSelection = true) {
        const index = this.checkInList(list, item);
        if (index === -1) {
            list.push(item[this.displayName]);
        } else {
            list.splice(index, 1);
        }
        if (emitSelection) {
            this.selectedListChange.emit(this.selectedList);
        }
    }

    checkInList(list: string[], item) {
        return list?.findIndex((el) => {
            return el === item[this.displayName];
        });
    }
}
